import ApiProvider from '../../../../core/api/ApiProvider';
import { ActionStatusType } from '../../../../core/types/ActionStatusType';

const InstallmentPlanApi = {
  GetInstallmentPlan: async (caseNumber: string) => {
    return await ApiProvider.get<ActionStatusType>(
      `InstallmentPlanModule/GetInstallmentPlan/${caseNumber}`
    );
  }
};

export default InstallmentPlanApi;
